import React from 'react';

class Accordion extends React.Component{

    static defaultProps = {
        id: "acc1",
        items: [
            {label:"Item 1", link:"item_1", content:"Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt raw denim aesthetic synth nesciunt sapiente ea proident. Aus labore sustainable VHS."},
            {label:"Item 2", link:"item_2", content:"Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod."},
            {label:"Item 3", link:"item_3", content:"Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda."}
        ],
        activeIndex: 0,
        className: "accordion",
        itemClasses: "card",
        itemHeaderClasses: "card-header",
        itemBodyClasses: "card-body",
        itemIconClasses: "float-right mt-1 icons icon-options-vertical"
    };
    
    render(){
        const { items, activeIndex } = this.props;
        return (
            <div className={this.props.className} id={this.props.id}>
                {items && items.length > 0 ? items.map((item,k) => (
                <div className={this.props.itemClasses} key={k}>
                    <div className={this.props.itemHeaderClasses}>
                        <a className="stretched-link" href={'#'+item.link} data-toggle="collapse" data-target={'#'+item.link}>
                            <span className={this.props.itemIconClasses}></span>
                          {item.label}
                        </a>
                    </div>
                    <div key={k} className={'collapse ' + (k===activeIndex?'show':'')} id={item.link} data-parent={'#'+this.props.id}>
                        <div className={this.props.itemBodyClasses} dangerouslySetInnerHTML={{ __html: item.content }} />
                    </div>
                </div>
                )):null}
            </div>
        );
    }
}

export default Accordion;
